import I18n from 'lib/i18n/i18n';
import {appUrl, BlogUrl, contentSiteUrl, marketPlaceUrl, rootUrl} from '../helpers/ApplicationHelper'

const HomePageData = () => {
  let homepageStrings = I18n.getString('homepage');
  let features = {
    link: "/blog/divorce/why-selling-your-engagement-ring-may-be-the-way-to-go/",
    image: "https://cdn1.worthy.com/cms/files/files/000/001/742/original/iaqe7x4fegbk8yjoijfc.jpg"
  };

  let userReviewsData = [
    {
      type:"userReviews",
      link: "https://www.google.com/maps/place/Worthy/@40.750684,-73.986733,17z/data=!3m1!4b1!4m14!1m6!3m5!1s0x89c258fe3c13a41d:0x81bd20ce3eb1da32!2sWorthy!8m2!3d40.75068!4d-73.984539!3m6!1s0x89c258fe3c13a41d:0x81bd20ce3eb1da32!8m2!3d40.75068!4d-73.984539!9m1!1b1",
      logo: "https://cdn1.worthy.com/cms/files/files/000/001/389/original/google.png"
    },
    {
      type:"userReviews",
      logo: "https://cdn1.worthy.com/cms/files/files/000/001/610/original/Trustpilot_b.png",
      link: "https://www.trustpilot.com/review/worthy.com"
    },
    {
      type:"userReviews",
      logo: "https://cdn1.worthy.com/cms/files/files/000/001/390/original/facebook.png",
      link:  "https://www.facebook.com/worthyInc/app/226132034107547"
    },
  ];
  let userReviews = userReviewsData.map( (data,idx) => {
    return {...data, ...homepageStrings.reviews.userReviews[idx]}
  });

  let asFeaturedInQuotes = [
    {
      citation: "https://www.nytimes.com/2017/12/03/business/media/worthy-divorce-rings.html",
      img: "https://cdn1.worthy.com/cms/files/files/000/001/739/original/cs6tmv2evy7rjrz18yl3.png"
    },
    {
      citation: "https://www.forbes.com/sites/anthonydemarco/2016/11/03/worthy-com-mines-a-new-market-for-old-diamonds/#11338ebd1cab",
      img: "https://cdn1.worthy.com/cms/files/files/000/001/741/original/dzhvpjijiemzrwbksvmr.png"
    },
    {
      citation: "https://www.inc.com/rohit-arora/diamonds-are-not-forever-why-worthy-is-a-girl-s-best-friend.html",
      img: "https://cdn1.worthy.com/cms/files/files/000/001/740/original/d6dirtxrugcoyxxdppf4.png"
    }
  ];
  let quotes = asFeaturedInQuotes.map((data,idx) => {
    return {...data, ...homepageStrings.asFeaturedIn.quotes[idx]}
  });

  let hamburgerTabs = [
    {
      'rootLink': `/about/how-it-works`,
      'mobile': 1,
    },
    {
      'rootLink': `/about/recent-deals`,
      'mobile': 2,
    },
    {
      'rootLink': '/about/reviews',
      'mobile': 3,
    },
    {
      'rootLink': '/signin',
      'app':true,
      'mobile': 5,
      login: false
    },
    {
      'rootLink': '/items',
      'mobile': 6,
      app: true,
      login: true
    },
    {
      'rootLink': '/refer_a_friend?lid={leadId}&uid={userId}',
      'mobile': 7,
      login: true
    }
  ];

  let hamburger = hamburgerTabs.map((tab,idx) => {
    return {...tab, title:Object.keys(homepageStrings.hamburger.titles).map((x) => homepageStrings.hamburger.titles[x])[idx]}
  });

  let expertsHamburger =  [
    { to: `${contentSiteUrl('/how-it-works/')}`, title: I18n.getString('experts::header::howItWorks') },
    { to: '#', title:  I18n.getString('experts::header::explore'), type: 'dropdown',
      subCategories: [
        { to: `${rootUrl('/about/recent-deals/rings')}`, title:  I18n.getString('experts::header::recentlySold') },
        { to: `${contentSiteUrl('/reviews/')}` , title:  I18n.getString('experts::header::reviews') },
        { to: `${BlogUrl('/')}`, title:  I18n.getString('experts::header::blog') },
        { to: `${rootUrl('/about/')}`, title:  I18n.getString('experts::header::aboutUs') },
      ]
    },
    // { to: `${marketPlaceUrl('/')}`, title:  I18n.getString('experts::header::buyARing'), beta: true },
  ];

  let submissionTabs = [
    {attr: {className: `ring tab`, 'data-form': 'showRingForm'}, text:'Ring'},
    {attr: {className: `jewelery tab`, 'data-form': 'showJewelryBoxForm'}, text:'Jewelery'},
  ];

  let howItWorksData = [
    {img: 'howItWorks/steps/01.svg'},
    {img: 'howItWorks/steps/02.svg',reverseMobile:true},
    {img: 'howItWorks/steps/03.svg'}
  ];
  let HIWStepPreviewData = howItWorksData.map((data,key) => {
    return { ...data, ...homepageStrings.howItWorks.stepPreview[`step${key + 1}`]}
  });

  let recentDeals = {
    requestParams: {
      min_value: 2500,
      count: 4,
      system_name: 'jewelry_rings',
      category: 'jewelry',
    },
    ...homepageStrings.recentDeals,
    label:'Explore marketplace - Ring',
    section:'RecentDeal',
    link: rootUrl('/about/recent-deals/rings')
  };

  return {
    ...homepageStrings,
    howItWorks: {
      ...homepageStrings.howItWorks, stepPreviewData: HIWStepPreviewData},
    reviews: {...homepageStrings.reviews, userReviews},
    asFeaturedIn: {...homepageStrings.asFeaturedIn, quotes},
    featuresAndNewsLetter: {...homepageStrings.featuresAndNewsLetter, features},
    hamburger,
    expertsHamburger,
    submissionForm:{
      ...homepageStrings.submissionForm,
      tabs:submissionTabs
    },
    recentDeals
  };
};

//Call it while loading to return hash map of all data
//TODO: this is always called, no matter which page we're loading. refactor.
export default HomePageData();
